var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectCompleted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#E7F7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 13.042C23.6306 13.042 25.1613 13.4777 26.4795 14.2402C26.7783 14.4131 26.8808 14.7959 26.708 15.0947C26.5352 15.3935 26.1523 15.4951 25.8535 15.3223C24.7204 14.6669 23.405 14.292 22 14.292C17.7428 14.292 14.292 17.7428 14.292 22C14.292 26.2572 17.7428 29.708 22 29.708C26.2572 29.708 29.708 26.2572 29.708 22C29.708 21.0497 29.5371 20.1406 29.2236 19.3018C29.1029 18.9785 29.2666 18.6189 29.5898 18.498C29.9131 18.3772 30.2737 18.541 30.3945 18.8643C30.7595 19.841 30.958 20.8981 30.958 22C30.958 26.9476 26.9476 30.958 22 30.958C17.0524 30.958 13.042 26.9476 13.042 22C13.042 17.0524 17.0524 13.042 22 13.042ZM29.0352 14.915C29.2661 14.6585 29.6614 14.6382 29.918 14.8691C30.1743 15.0999 30.1954 15.4944 29.9648 15.751L23.5166 22.916C22.7045 23.8183 21.3298 23.9302 20.3818 23.1719L17.4434 20.8213C17.1738 20.6057 17.1302 20.2129 17.3457 19.9434C17.5613 19.6738 17.9541 19.6301 18.2236 19.8457L21.1621 22.1963C21.593 22.541 22.2187 22.4902 22.5879 22.0801L29.0352 14.915Z",
    fill: "#088B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCompleted);
export default __webpack_public_path__ + "static/media/project_completed.c06ba04c8554d8699262c8ed9ab327f7.svg";
export { ForwardRef as ReactComponent };